import { createReducer } from "./functions";

import { IOCS_SET_LIST } from '../types';

const initialState = {
  iocsList: [],
  page: 0,
  pages: 0,
  pageSize: 10
}

const setIocsList = {
  [IOCS_SET_LIST]: (state, action) => {
    const page = action.payload.hasOwnProperty("page")
    ? action.payload.page
    : state.page;
    const pages = action.payload.hasOwnProperty("pages")
      ? action.payload.pages
      : state.pages;
    let hasNext = true;

    if (page === 0 || page === pages)
      hasNext = false;
    return { ...state, iocsList: action.payload.docs, page, pages, hasNext };
  }
}
const iocsReducer = createReducer(initialState, {
  ...setIocsList
})

export default iocsReducer;


// WEBPACK FOOTER //
// src/redux/reducers/iocsReducer.js